import { createUseStyles } from 'react-jss';
import { SpacingsValues } from '@picsart/cascade';

import { ITheme } from '../../../styles/theme';
import noSelect from '../../../styles/noselect';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      borderBottom: '1px solid var(--x-bg-9)',
    },
    titleContainer: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      paddingBlock: SpacingsValues.s24,
      ...noSelect,
    },
    title: {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '24px',
      paddingBlock: SpacingsValues.s12,
    },
    description: {
      fontSize: 16,
      lineHeight: '24px',
      height: 0,
      overflow: 'hidden',
      transition: 'height 0.25s ease-out',

      '& ol': {
        paddingLeft: 18,
        paddingBottom: 16,
      },
      '& ul': {
        listStyleType: 'disc',
        paddingLeft: 18,
        paddingBottom: 16,
      },
      '& div': {
        paddingBottom: 16,
      },
      '& li': {
        paddingBlock: 4,
      },
      '& span': {
        display: 'block',
        marginTop: 8,
      },
      '& a': {
        color: 'var(--x-black-1)',
        textDecoration: 'underline',
      },
    },
    icon: {
      fill: 'var(--x-black-1)',
      transition: 'all 0.3s ease-in-out',
      width: 24,
    },
    iconExpanded: {
      transform: 'rotate(180deg)',
    },
    descriptionExpanded: {
      marginBottom: SpacingsValues.s16,
    },
    expanded: {
      '& $titleContainer': {
        paddingBottom: 0,
        marginBottom: SpacingsValues.s8,
      },
    },
  }),
  {
    name: 'FaqItem',
  },
);

export default useStyles;
